export default __webpack_public_path__ + "static/media/share-grey-14px.3c13ac20.svg";